import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10 16H10.01M6 19H14C15.1046 19 16 18.1046 16 17V3C16 1.89543 15.1046 1 14 1H6C4.89543 1 4 1.89543 4 3V17C4 18.1046 4.89543 19 6 19Z" />
  </svg>
);
